import React from 'react'

import WarningIcon from '../../assets/icons/warning.svg?react'

interface AuthErrorBannerProps {
  message: string
}

export const AuthErrorBanner: React.FC<AuthErrorBannerProps> = ({ message }) => {
  return (
    <div className="flex items-start gap-2.5 bg-danger/10 border border-danger/30 rounded-xl px-3 py-2.5">
      <WarningIcon className="size-4 flex-none mt-0.5 text-danger" />
      <span className="text-sm leading-snug text-danger">{message}</span>
    </div>
  )
}
